import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import $ from 'jquery';

import APFormGroup from 'components/FormFields/APFormGroup';
import { checkInputForCardData } from 'utils/payments';
import { parseFsMessage } from '../utils/messages';

window.jQuery = $;

const CreditCard = ({
  authKey,
  disableDupDetection,
  chargeAmount,
  identifier,
  setErrorMessage,
  setResponse,
  setDisableSubmit,
}) => {
  // Manage pseudo focus state from iframe elements.
  const [isCardNumFocused, setCardNumFocused] = useState(false);
  const [isExpMonthFocused, setExpMonthFocused] = useState(false);
  const [isExpYearFocused, setExpYearFocused] = useState(false);
  const [isCvvFocused, setCvvFocused] = useState(false);

  // Manage error states from iframe elements.
  const [cardNumberError, setCardNumberError] = useState('');
  const [expMonthError, setExpMonthError] = useState('');
  const [expYearError, setExpYearError] = useState('');
  const [cvvError, setCvvError] = useState('');

  const [cardType, setCardType] = useState(null);


  // emitted function names from hosted payments messages.
  /* eslint-disable */
  const cardNumberTypeChanged = (type) => setCardType(type);

  const cardNumberFocusIn = () => setCardNumFocused(true);
  const cardNumberFocusOut = () => setCardNumFocused(false);

  const expirationMonthFocusIn = () => setExpMonthFocused(true);
  const expirationMonthFocusOut = () => setExpMonthFocused(false);

  const expirationYearFocusIn = () => setExpYearFocused(true);
  const expirationYearFocusOut = () => setExpYearFocused(false);

  const cvvFocusIn = () => setCvvFocused(true);
  const cvvFocusOut = () => setCvvFocused(false);

  const cardNumberValid = () => setCardNumberError('');
  const cardNumberInvalid = () => setCardNumberError('The Card Number field is invalid.');

  const cardNumberValidation = (type) => {
    if (type === 'false') {
      setCardNumberError('The Card Number field is invalid.');
    } else {
      setCardNumberError('');
    }
  }

  const expirationMonthValid = () => setExpMonthError('');
  const expirationMonthInvalid = () => setExpMonthError('The Exp Month field is required.');

  const expirationMonthValue = (value) => {
    if(value === '0') {
      setExpMonthError('The Exp Month field is required.');
    } else {
      setExpMonthError('');
    }
  }

  const expirationYearValid = () => setExpYearError('');
  const expirationYearInvalid = () => setExpYearError('The Exp Year field is required.')

  const expirationYearValue = (value) => {
    if(value === '0') {
      setExpYearError('The Exp Year field is required.');
    } else {
      setExpYearError('');
    }
  }

  const cvvValid = () => setCvvError('');
  const cvvInvalid = () => setCvvError('The CVV field is invalid.');

  const cvvValidation = (type) => {
    if (type === 'false') {
      setCvvError('The CVV field is invalid.');
    } else {
      setCvvError('');
    }
  }
  /* eslint-enable */
  // end emitted function names from hosted payments messages.

  const renderCardType = () => {
    if (!cardType) return;

    if (cardType === 'visa') {
      return (
        <FontAwesomeIcon icon={['fab', 'cc-visa']}
          alt="Visa"
        />
      );
    }
    if (cardType === 'mastercard') {
      return (
        <FontAwesomeIcon icon={['fab', 'cc-mastercard']}
          alt="Mastercard"
        />
      );
    }
    if (cardType === 'discover') {
      return (
        <FontAwesomeIcon icon={['fab', 'cc-discover']}
          alt="Discover"
        />
      );
    }
    if (cardType === 'amex') {
      return (
        <FontAwesomeIcon icon={['fab', 'cc-amex']}
          alt="American Express"
        />
      );
    }
  };

  const handleFsMessage = (e) => {
    const [functionName, arg] = parseFsMessage(e);
    try {
      // eslint-disable-next-line no-eval
      eval(functionName)(arg);
    } catch (err) {
      // Do Nothing
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleFsMessage);
    return () => {
      window.removeEventListener('message', handleFsMessage);
    };
  }, []);

  useEffect(() => {
    if (cardNumberError || expMonthError || expYearError || cvvError) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [cardNumberError, expMonthError, expYearError, cvvError]);

  function handleOnLoad() {

    let invoiceNum = (identifier.length > 20) ? identifier.substring(0,20) : identifier;
    if (checkInputForCardData(invoiceNum)) {
      const filteredInvoiceNum = ((invoiceNum.length > 14) ? invoiceNum.substring(0,14) : invoiceNum);
      invoiceNum = `ap_${filteredInvoiceNum}_cc`;
    }

    const fullsteamHostedPaymentsParameters = {
      authenticationKey: authKey,
      operationType: 'Payment',
      formId: 'payment-form',
      cardEntryContext: 'WebConsumerInitiated',
      nameOnAccountField: 'NameOnAccount',
      firstNameField: 'FirstName',
      middleNameField: 'MiddleName',
      lastNameField: 'LastName',
      address1Field: 'Address1',
      cityField: 'City',
      stateField: 'State',
      zipField: 'Zip',
      countryField: 'Country',
      phoneField: 'Phone',
      emailField: 'Email',
      paymentAmount: chargeAmount,
      invoiceNumber: invoiceNum,
      customerId: invoiceNum,
      includeTokenInResponse: true,
      allowPartialAuthorization: false,
      disableDuplicateDetection: disableDupDetection,
    };

    function handleHostedPaymentsError(errorMessage) {
      setErrorMessage(errorMessage);
      setDisableSubmit(false);
    }

    function handleGatewayError(gatewayResponse) {
      setResponse(gatewayResponse);
    }

    $(document).ready(() => {
      // Add Callbacks
      fullsteamHostedPaymentsParameters.gatewayErrorCallback = handleGatewayError;
      fullsteamHostedPaymentsParameters.hostedPaymentsSimpleError = handleHostedPaymentsError;

      // eslint-disable-next-line no-undef
      const setupSuccessful = setupFullsteamHostedPayments(fullsteamHostedPaymentsParameters);
      if (!setupSuccessful) {
        $('#submitButton').toggle(false);
      }
    });
  }

  const handleScriptInject = ({ scriptTags }) => {
    if (scriptTags) {
      const scriptTag = scriptTags[0];
      scriptTag.onload = handleOnLoad;
    }
  };

  return (
    <>
      <Helmet
        script={[
          { src: `${process.env.REACT_APP_FULLSTEAM_JS_URL}` },
          { src: 'https://code.jquery.com/ui/1.12.1/jquery-ui.min.js',
            integrity: 'sha256-VazP97ZCwtekAsvgPBSUwPFKdrwD3unUfSGVYrahUqU=',
            crossOrigin: 'anonymous',
          },
          { src: 'https://ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/jquery.validate.min.js',
            crossOrigin: 'anonymous',
            integrity: 'sha384-rZfj/ogBloos6wzLGpPkkOr/gpkBNLZ6b6yLy4o+ok+t/SAKlL5mvXLr0OXNi1Hp' },
          { src:
            'https://ajax.aspnetcdn.com/ajax/jquery.validation.unobtrusive/3.2.9/jquery.validate.unobtrusive.min.js',
            crossOrigin: 'anonymous',
            integrity: 'sha384-ifv0TYDWxBHzvAk2Z0n8R434FL1Rlv/Av18DXE43N/1rvHyOG4izKst0f2iSLdds',
          },
        ]}
        onChangeClientState={(newState, addedTags) => {
          // if (selected.includes('credit')) return;
          // localStorage.setItem('selected', `${selected},credit`);
          handleScriptInject(addedTags);
        }}
      />
      <APFormGroup
        gridGap={1}
        verticalGap={0}
      >
        <div className="form-item form-item--iframe form-item--w-50">
          <label className="control-label">Card Number</label>
          <div className="form-item__card-type">
            {renderCardType()}
          </div>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isCardNumFocused && 'focus', cardNumberError && 'error')}
              id="fullsteam-hosted-card-number-div"
            />
          </div>
          <div className="form-item__error"
            id="fullsteam-hosted-card-number-error"
          >
            {cardNumberError}
          </div>
        </div>

        <div className="form-item form-item--iframe">
          <label className="control-label">Exp Month</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isExpMonthFocused && 'focus', expMonthError && 'error')}
              id="fullsteam-hosted-expiration-month-div"
            />
          </div>
          <div className="form-item__error"
            id="fullsteam-hosted-expiration-month-error"
          >
            {expMonthError}
          </div>
        </div>

        <div className="form-item form-item--iframe">
          <label className="control-label">Exp Year</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isExpYearFocused && 'focus', expYearError && 'error')}
              id="fullsteam-hosted-expiration-year-div"
            />
          </div>
          <div className="form-item__error"
            id="fullsteam-hosted-expiration-year-error"
          >
            {expYearError}
          </div>
        </div>

        <div className="form-item form-item--iframe">
          <label className="control-label">CVV</label>
          <div className="form-item__frame">
            <div className={clsx('iframe-input', isCvvFocused && 'focus', cvvError && 'error')}
              id="fullsteam-hosted-cvv-div"
            />
          </div>
          <div className="form-item__error"
            id="fullsteam-hosted-cvv-error"
          >
            {cvvError}
          </div>
        </div>
      </APFormGroup>
    </>
  );
};

export default CreditCard;
